import type { JournalOrderRequestDTO } from '~/shared/api/client/journals/journals.dto';

/** The fields the buyer fills in; the rest of the request the form derives */
export type JournalOrderFieldName = Exclude<
  keyof JournalOrderRequestDTO,
  'journal' | 'captcha_token'
>;

export interface JournalOrderFieldDescriptor {
  name: JournalOrderFieldName;
  /** Drawn as the placeholder — the layout gives the fields no labels of their own */
  label: string;
  required: boolean;
}

/**
 * Source order is the order of the layout: the grid fills row by row, so the
 * pairs read «ФИО — Компания», «Сфера — Должность», «Email — Телефон»,
 * «Промокод — Комментарий»
 */
export const JOURNAL_ORDER_FIELDS: JournalOrderFieldDescriptor[] = [
  { name: 'full_name', label: 'ФИО плательщика', required: true },
  { name: 'company', label: 'Компания', required: true },
  {
    name: 'business_field',
    label: 'Сфера деятельности компании',
    required: true,
  },
  { name: 'position', label: 'Должность', required: true },
  { name: 'email', label: 'Email', required: true },
  { name: 'phone', label: 'Телефон', required: true },
  { name: 'promo_code', label: 'Промокод', required: false },
  { name: 'comment', label: 'Комментарий к заказу', required: false },
];

/** The same address the footer links to */
export const PRIVACY_POLICY_URL = 'https://cre.ru/privacy_policy';

export const JOURNAL_ORDER_PAYMENT_NOTE =
  'Оплата осуществляется через выставление счета юр.лицу';

/**
 * One line under the form rather than a message per field: an invalid field is
 * already marked red, and the line only has to say what to look at
 */
export const JOURNAL_ORDER_ERRORS = {
  required: 'Заполните обязательные поля',
  email: 'Проверьте адрес электронной почты',
  phone: 'Проверьте номер телефона',
  captcha: 'Подтвердите, что вы не робот',
  request: 'Не удалось отправить заявку. Попробуйте ещё раз',
} as const;

/** Yandex SmartCaptcha site key — public by design, the secret one lives on the backend */
export const SMARTCAPTCHA_CLIENT_KEY =
  'ysc1_AGuK8tHgvSwkKvbkjsniqf2AbIHWrdyNradR0HEN7fc74e7b';
